import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable */
// There is an issue with cancelable interface
// It is not obvious that
// `image(src)` has `cancel` function
// but `image(src).then()` doesn't

import { unfetch, UnfetchAbortController } from "./unfetch";

/**
 * returns new "promise" with cancel function combined
 *
 * @param {Promise} p1 - first "promise" with cancel
 * @param {Promise} p2 - second "promise" with cancel
 * @returns {Promise} - new "promise" with cancel
 */
export var combineCancel = function combineCancel(p1, p2) {
  if (!p2) return p1;
  var result = p1.then(function (x) {
    return x;
  }, function (x) {
    return x;
  });
  result.cancel = function () {
    p1.cancel();
    p2.cancel();
  };
  return result;
};
export var timeout = function timeout(threshold) {
  var timerId;
  var result = new Promise(function (resolve) {
    timerId = setTimeout(resolve, threshold);
  });
  result.cancel = function () {
    // there is a bug with cancel somewhere in the code
    // if (!timerId) throw new Error('Already canceled')
    clearTimeout(timerId);
    timerId = undefined;
  };
  return result;
};

// Caveat: image loader can not cancel download in some browsers
export var imageLoader = function imageLoader(src) {
  var img = new Image();
  var result = new Promise(function (resolve, reject) {
    img.onload = resolve;
    // eslint-disable-next-line no-multi-assign
    img.onabort = img.onerror = function (error) {
      return reject(error);
    };
    img.src = src;
  });
  result.cancel = function () {
    if (!img) throw new Error('Already canceled');
    // eslint-disable-next-line no-multi-assign
    img.onload = img.onabort = img.onerror = undefined;
    img.src = '';
    img = undefined;
  };
  return result;
};

// Caveat: XHR loader can cause errors because of 'Access-Control-Allow-Origin'
// Caveat: we still need imageLoader to do actual decoding,
// but if images are uncachable this will lead to two requests
export var xhrLoader = function xhrLoader(url, options) {
  var controller = new UnfetchAbortController();
  var signal = controller.signal;
  var result = new Promise(function (resolve, reject) {
    return unfetch(url, _objectSpread(_objectSpread({}, options), {}, {
      signal: signal
    })).then(function (response) {
      if (response.ok) {
        response.blob().then(function () {
          return imageLoader(url);
        }).then(resolve);
      } else {
        reject(new Error(response));
      }
    }, reject);
  });
  result.cancel = function () {
    if (!controller) throw new Error('Already canceled');
    controller.abort();
    controller = undefined;
  };
  return result;
};